import script from "./AttributeCoverage.vue?vue&type=script&setup=true&lang=js"
export * from "./AttributeCoverage.vue?vue&type=script&setup=true&lang=js"

import "./AttributeCoverage.vue?vue&type=style&index=0&id=6d18d0ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d18d0ea"]])

export default __exports__